import { createSlice } from "@reduxjs/toolkit";

const setLoading = (state, value) => {
  state.isLoading = value;
};

const setSuccessWithData = (state, data, key) => {
  state.isLoading = false;
  state[key] = data;
};

const setFailure = (state) => {
  state.isLoading = false;
};

const complainSlice = createSlice({
  name: "Complain",
  initialState: {
    isLoading: false,
    suplier: {},
    complainList: [],
  },
  reducers: {
    // login
    getComplainRequest: (state) => setLoading(state, true),
    getComplainSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "complainList"),
    getComplainFailure: (state) => setLoading(state, false),
  },
});

export const { getComplainRequest, getComplainSuccess, getComplainFailure } =
complainSlice.actions;

export const complainReducerSlice = complainSlice.reducer;
